// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1CmNZuZUMkfRel2oWEc2lo","loading":"_1VsW4z5D03ifDXoIAdCBzX"};